namespace HA.Core.HTML {
    //noinspection TsLint
    export class ExtWindow extends Window {
        protected initialize(data: any) {

            super.initialize(data);
            this.initFrame(toMap(data));
        }

        protected initFrame(d: Map<any,any>) {
            d.delete("tag");
            d.delete("element");
            this.appendChild(new HA.Core.HTML.Iframe(d));
        }
    }
}
